import { useId } from 'react';
import { cn } from '@/lib/utils';

/**
 * Wordmark: three candles — bullish in gold, bearish in silver — plus the name.
 *
 * The same mark as the app icon (public/icon-v5.svg), drawn in the icon's own
 * coordinates and cropped by the viewBox. Inline SVG so it needs no asset
 * request; the metals are fixed rather than themed, since they are the brand
 * colours and read on both the light and dark top bar.
 */
export function Logo({ className }: { className?: string }) {
  // Gradient ids must be unique per page, or two logos would share one.
  const id = useId();
  const gold = `${id}-gold`;
  const silver = `${id}-silver`;

  return (
    <span className={cn('flex items-center gap-2', className)}>
      <svg viewBox="70 76 372 340" className="h-full w-auto" aria-hidden="true">
        <defs>
          <linearGradient id={gold} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor="#fff1b8" />
            <stop offset="0.35" stopColor="#fbbf24" />
            <stop offset="1" stopColor="#a85a08" />
          </linearGradient>
          <linearGradient id={silver} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor="#ffffff" />
            <stop offset="0.35" stopColor="#d7dde6" />
            <stop offset="1" stopColor="#6b7383" />
          </linearGradient>
        </defs>
        {/* bullish gold, bearish silver, bullish gold */}
        <rect x="110" y="232" width="16" height="176" rx="8" fill="#e8a52a" />
        <rect x="78" y="268" width="80" height="112" rx="16" fill={`url(#${gold})`} />
        <rect x="248" y="160" width="16" height="200" rx="8" fill="#aeb6c3" />
        <rect x="216" y="196" width="80" height="120" rx="16" fill={`url(#${silver})`} />
        <rect x="386" y="84" width="16" height="232" rx="8" fill="#e8a52a" />
        <rect x="354" y="116" width="80" height="168" rx="16" fill={`url(#${gold})`} />
      </svg>
      <span className="text-[15px] font-semibold tracking-tight">
        Pip<span className="text-gold">yar</span>
      </span>
    </span>
  );
}
